var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDividerVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 16,
    viewBox: "0 0 1 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Divider (Vertical)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Divider Line",
    width: 1,
    height: 16,
    fill: "#DFE2E7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerVertical);
export default __webpack_public_path__ + "static/media/divider_vertical.391884ef156f7ebd2b2669fb49af30ae.svg";
export { ForwardRef as ReactComponent };